(function () {
  'use strict';

  angular
    .module('dashboard.project.alltime')
    .factory('DashboardProjectAlltime', DashboardProjectAlltime);

  DashboardProjectAlltime.$inject = ['$resource'];

  function DashboardProjectAlltime($resource) {
    return $resource(
      '/api/',
      {},
      {
        getProjects: {
          method: 'GET',
          url: '/api/object/all',
          isArray: true,
          cache: true,
        },
        getProjectAlltime: {
          method: 'GET',
          url: '/api/dashboard/project_alltime/:period/:project',
          isArray: true,
        },
      },
    );
  }
})();
